export const getPromptCreatePageUrl = (territorySlug: string) => `/prompt/create?territorySlug=${territorySlug}`;
